import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useWalletBalance } from 'services/walletService';
import { toast } from 'react-toastify';

type Props = {
    amount: number;
    payUrl: string; // e.g. `${CONFIG.apiUrl}/offer/${offer._id}/pay-with-wallet`
    successRedirect: string; // e.g. '/admin/paiement-success'
};

const PayWithWalletButton = ({ amount, payUrl, successRedirect }: Props) => {
    const { walletBalance, loading } = useWalletBalance();
    const [submitting, setSubmitting] = useState(false);
    const navigate = useNavigate();

    if (loading) return null;

    const hasEnoughBalance = walletBalance >= amount;

    const handlePay = async () => {
        setSubmitting(true);
        try {
            await axios.post(
                payUrl,
                {},
                { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
            );
            navigate(successRedirect);
        } catch (error: any) {
            toast.error(error.response?.data?.error || error.response?.data?.message || 'Erreur lors du paiement');
            setSubmitting(false);
        }
    };

    if (!hasEnoughBalance) {
        return (
            <p className="font-geist text-sm text-leadrs-text-soft">
                Solde de la cagnotte insuffisant ({walletBalance.toFixed(2)}€ disponible).{' '}
                <span
                    className="cursor-pointer text-leadrs-brand underline hover:opacity-80"
                    onClick={() => navigate('/admin/wallet/topup')}
                >
                    Ajouter des crédits
                </span>
            </p>
        );
    }

    return (
        <button
            className="w-full rounded-lg border border-leadrs-stroke bg-white px-5 py-3 font-geist text-sm font-medium text-leadrs-text transition-colors hover:border-leadrs-brand disabled:cursor-not-allowed disabled:opacity-60"
            onClick={handlePay}
            disabled={submitting}
        >
            {submitting ? 'Paiement en cours...' : `Payer avec mon solde (${walletBalance.toFixed(2)}€ disponible)`}
        </button>
    );
};

export default PayWithWalletButton;
